<!-- 设备管理-设备列表页面 -->
<template>
  <div class="vcnDeviceList">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <div class="left_title">设备信息</div>
        <div class="device-tab">
          <div
            v-for="item in calType.column"
            :key="item.typeId"
            :class="['tab', type.prop == item.prop ? 'active' : '']"
            @click="handleChange(item)"
          >
            {{ item.label }}
          </div>
        </div>
        <!-- <ioc-tab-group :option="calType"
                       @change="handleChange"></ioc-tab-group> -->
        <div v-if="type.prop === 'tab1'" class="left-type_area">
          <ele-group-tree
            @getCode="getDeviceWrokGroupCode"
            @sendData="getDeviceTreeData"
            :deviceType="checkDevType"
            :paramsType="paramsType"
            @refresh="initGet()"
          ></ele-group-tree>
        </div>
        <div v-show="type.prop === 'tab2'" class="left-type_area sbar">
          <div class="device-search">
            <el-input
              placeholder="请输入搜索关键字"
              prefix-icon="el-icon-search"
              v-model="searchString"
              clearable
            >
            </el-input>
          </div>
          <el-scrollbar class="flex-auto" style="height: calc(100% - 50px)">
            <el-tree
              ref="tree"
              class="mb20"
              node-key="areaDevGroupCode"
              :default-expand-all="true"
              :data="areaTreeData"
              :highlight-current="true"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
            >
              <template slot-scope="{ node }">
                <element-tree-line
                  :node="node"
                  :showLabelLine="true"
                  :indent="16"
                  class="tree-line"
                >
                  <span class="custom-tree-node" style="display: block">
                    <i class="el-icon-document"></i>
                    <span style="margin-left: 3px">{{ node.label }}</span>
                  </span>
                </element-tree-line>
              </template>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 主机设备列表 -->
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar flex-row">
          <el-button
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-iconfontfanhui"
            @click="
              () => {
                $router.push('/cameralist/devicelist');
              }
            "
            >返回</el-button
          >
          <el-button
            type="primary"
            v-auth="'/cameralist/devicelist:move'"
            class="iss-operation-button"
            icon="iconfont icon-jinru"
            @click="moveIn"
            >{{ $t("cameraList.button.moveInto") }}</el-button
          >
          <el-button
            v-auth="'/cameralist/devicelist:export'"
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-daochu"
            @click="exportDocument"
            >{{ $t("cameraList.button.export") }}</el-button
          >
        </div>
        <div class="section-main__filter" v-if="false">
          <!-- 按照设备划分 -->
          <el-row>
            <el-form
              label-width="90px"
              label-position="left"
              :inline="true"
              size="small"
              class="demo-form-inline"
            >
              <el-col :span="5">
                <el-form-item label="设备名称">
                  <el-input
                    v-model="searchForm.deviceName"
                    clearable
                    placeholder="请输入设备名称"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="设备ID">
                  <el-input
                    v-model="searchForm.thirdDeviceId"
                    clearable
                    placeholder="请输入设备ID"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="5">
                <el-form-item label="状态">
                  <el-select
                    v-model="searchForm.status"
                    clearable
                    placeholder="请选择设备状态"
                  >
                    <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="楼栋" style="position: relative">
                  <el-input
                    v-model="searchForm.buildingName"
                    clearable
                    placeholder="请选择楼栋"
                    disabled="disabled"
                    @click.native="openBuilding"
                  >
                  </el-input>
                  <!-- <el-button type="text"
                               size="small"
                               class="iconfont icon-position map-choose"
                               @click="openBuilding"></el-button> -->
                </el-form-item>
              </el-col>
              <el-col :span="4" style="margin-top: 30px">
                <el-form-item>
                  <el-button type="primary" @click="handleSearchChange">{{
                    $t("cameraList.button.search")
                  }}</el-button>
                  <el-button type="info" @click="resetForm">{{
                    $t("cameraList.button.reset")
                  }}</el-button>
                </el-form-item>
              </el-col>

              <!-- <el-col :span="4">
                  <el-button type="primary"
                             @click="queryDevList">{{ $t('cameraList.button.search') }}</el-button>
                  <el-button type="info"
                             @click="resetQuery">{{ $t('cameraList.button.reset') }}</el-button>
                </el-col> -->
            </el-form>
          </el-row>
        </div>
        <!-- 表格部分 -->
        <div class="section-main_table">
          <ioc-table
            ref="devTab"
            :data="deviceData"
            :option="deviceOption"
            :page="devicePage"
            @search-change="handleSearchChange"
            @search-reset="resetForm"
            @current-change="selectPage"
            @selection-change="selectionChange"
            @size-change="changeSize"
          >
            <!-- 定制操作栏按钮 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="修改"
                placement="top"
                v-auth="'/cameralist/devicelist:update'"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  @click="update(scope.row)"
                  icon="iconfont icon-xiugai"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  class="iconfont icon-Detail"
                  @click="showDetail(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="告警详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  @click="getAlarm(scope.row)"
                  icon="iconfont icon-chakan"
                ></el-button>
              </el-tooltip>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <!--告警信息-->
    <el-dialog
      title="告警详情"
      class="alarm-dialog"
      :visible.sync="alarmDialog"
      v-dialogDrag
      width="70%"
      :close-on-click-modal="false"
      @close="alarmDialog = false"
    >
      <div style="height: 400px">
        <ioc-table
          ref="alarmTab"
          :data="alarmData"
          :option="alarmOption"
          :page="alarmPage"
          @current-change="alarmSelectPage"
          @size-change="alarmChangeSize"
        >
        </ioc-table>
      </div>
    </el-dialog>
    <!-- add+update设备数据弹框  -->
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="editDevDialog"
      @cancel="editDlgCan"
      :title="dialogTitle"
    >
      <!-- <el-dialog
      :title="dialogTitle"
      :close-on-click-modal="false"
      v-dialogDrag
      :visible.sync="editDevDialog"
      width="66%"
      :center="true"
    > -->
      <edit-dev ref="editDev"></edit-dev>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDlgCan" type="info">{{
          diaLoading ? "保存中..." : "取 消"
        }}</el-button>
        <el-button type="primary" :loading="diaLoading" @click="editDlgPre">{{
          diaLoading ? "保存中..." : "保 存"
        }}</el-button>
      </span>
      <!-- </el-dialog> -->
    </appPanel>

    <!--楼栋树-->
    <el-dialog
      title="选择楼栋楼层"
      v-ops:width="380"
      :visible.sync="showBuilding"
      center
    >
      <el-tree
        :data="treeData"
        node-key="id"
        :default-expanded-keys="expandedKeys"
        render-after-expand
        :highlight-current="true"
        :props="deviceBuildingProps"
        @node-click="selectBuilding"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="buildConfirm">确定</el-button>
        <el-button @click="showBuilding = false">取消</el-button>
      </span>
    </el-dialog>
    <!--选择设备树-->
    <el-dialog
      v-ops:width="380"
      width="30%"
      v-dialogDrag
      :title="type.prop === 'tab1' ? '选择挪入设备组' : '选择挪入区域'"
      :visible.sync="deviceTreeShow"
      center
    >
      <el-tree
        :data="deviceTreeData"
        v-show="type.prop === 'tab1'"
        :highlight-current="true"
        :props="deviceDefaultProps"
        @node-click="selectDeviceNode"
      ></el-tree>
      <el-tree
        :data="areaTreeData"
        v-show="type.prop === 'tab2'"
        :highlight-current="true"
        :props="defaultProps"
        @node-click="selectAreaNode"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="moveInDevice">{{
          $t("cameraList.button.conform")
        }}</el-button>
        <el-button @click="deviceTreeShow = false">{{
          $t("cameraList.button.cancel")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import appPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic, Cache } from "$utils";
import { alarmOption } from "../const/alarmDetail";
import { tableOption } from "../const/electricDeviceTable";
import eleGroupTree from "../components/equipmentGroupTree";
import editDev from "./electricDeviceDia";
import ElementTreeLine from "element-tree-line";
//import editDev from '../../deviceAccess/components/VCN/electricFireDia'
export default {
  components: {
    editDev,
    eleGroupTree,
    ElementTreeLine,
    appPanel,
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      alarmPage: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      searchString: "",
      alarmOption: alarmOption(this),
      stateList: [
        {
          label: "在线",
          value: "1",
        },
        {
          label: "离线",
          value: "0",
        },
        {
          label: "故障",
          value: "2",
        },
      ],
      searchForm: {},
      expandedKeys: [],
      deviceBuildingProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      alarmDialog: false,
      treeData: Object.freeze([]),
      // defaultBuildingProps: {
      //   children: 'areaChildren',
      //   label: 'areaDevGroupName'
      // },
      showBuilding: false,
      //左侧tab切换
      calType: {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1",
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2",
          },
        ],
      },
      type: {
        label: this.$t("cameraList.label.deviceSet"),
        prop: "tab1",
      },
      checkDevType: "",
      paramsType: "",
      deviceData: [],
      deviceWorkGroupCode: "",
      deviceOption: tableOption(true, false),
      // 分页属性设置
      devicePage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      // 查询字段
      queryForm: {
        deviceName: "",
        thirdDeviceId: "",
        buildingCode: "",
        status: "",
      },

      // 请求设备列表的数据对象
      getDevPra: {},
      dialogTitle: "修改设备",
      editDevDialog: false,
      diaLoading: false,
      deviceTreeData: [],
      areaTreeData: [],
      deviceTreeShow: false,
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName",
      },
      deviceDefaultProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      selDev: [],
      areaDevGroupCode: "",
      // 判断是否勾选查询无区域
      isArea: "",
      status: "",
      alarmData: [],
    };
  },
  created() {
    this.setCheckDevType();
    this.getAreaTree();
    this.getDevList();
  },
  mounted() {
    // 请求设备列表
    if (this.$route.query.device) {
      this.cacheRouterInfo = this.$route.query.device;
    }
    //  if(this.$route.query.device){
    //   this.cacheRouterInfo = this.$route.query.device
    // }
  },
  destroyed() {
    Cache.remove("deviceTypeName");
    Cache.remove("deviceTypeId");
  },
  methods: {
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.areaDevGroupName.indexOf(value) !== -1;
    },
    selectBuilding(data) {
      this.searchForm.buildingName = "";
      this.searchForm.buildingName = data.name;
      this.searchForm.buildingCode = data.id;
    },
    buildConfirm() {
      this.searchForm.buildingName = this.searchForm.buildingName;
      this.searchForm.buildingCode = this.searchForm.buildingCode;
      this.showBuilding = false;
    },
    //告警详情
    alarmChangeSize(val) {
      this.alarmPage.pageSize = val;
      this.alarmPage.pageNum = 1;
      this.queryAlarmData();
    },
    // 点击上一页下一页按钮
    alarmSelectPage(val) {
      this.alarmPage.pageNum = val;
      this.queryAlarmData();
    },

    //挪入
    moveIn() {
      if (this.selDev.length <= 0) {
        this.$message({
          message: this.$t("cameraList.message.chooseEnter"),
          type: "warning",
        });
        return;
      }
      this.slectedAreaNode = "";
      this.deviceTreeShow = true;
      this.getAreaTree();
    },

    //迭代四  新接口 查看详情
    showDetail(row) {
      // if (row.isIndoor == "1") {
      //   this.$refs.devTab.option.column[14].viewDisplay = false;
      //   this.$refs.devTab.option.column[15].viewDisplay = false;
      //   this.$refs.devTab.option.column[11].viewDisplay = true;
      //   this.$refs.devTab.option.column[12].viewDisplay = true;
      //   this.$refs.devTab.option.column[13].viewDisplay = true;
      //   this.$refs.devTab.option.column[16].viewDisplay = true;
      //   this.$refs.devTab.option.column[17].viewDisplay = true;
      // } else {
      //   this.$refs.devTab.option.column[14].viewDisplay = true;
      //   this.$refs.devTab.option.column[15].viewDisplay = true;
      //   this.$refs.devTab.option.column[11].viewDisplay = false;
      //   this.$refs.devTab.option.column[12].viewDisplay = false;
      //   this.$refs.devTab.option.column[13].viewDisplay = false;
      //   this.$refs.devTab.option.column[16].viewDisplay = false;
      //   this.$refs.devTab.option.column[17].viewDisplay = false;
      //   // console.log('================fewhhufiwuie00000', this.$refs.editDev)
      // }
      this.$refs.devTab.rowView(row);
    },
    //查看告警详情
    getAlarm(data) {
      // console.log(data, "=====data");
      this.thirdDeviceId = data.thirdDeviceId;

      // this.$router.push({
      //   path: '/cameralist/alarmDetailList',
      //   name: 'alarmDetailList',
      //   query: { alarm: data }
      // })
      // console.log(data, '告警详情');
      this.alarmDialog = true;
      this.queryAlarmData();
      // const param = {
      //   pageNum: this.alarmPage.pageNum,
      //   pageSize: this.alarmPage.pageSize,
      //   thirdDeviceId: data.thirdDeviceId
      // }
      // this.$fetch(api.electricDevice.queryElectricalFireAlarmInfo, param).then((res) => {
      //   if (res.success) {
      //     console.log(res, '====res告警')
      //     this.alarmData = res.returnObj.list;
      //     this.alarmPage.total=res.returnObj.total;
      //   } else {
      //     this.$message.error(res.msgContent);
      //   }

      // })
    },
    queryAlarmData() {
      const params = {
        pageNum: this.alarmPage.pageNum,
        pageSize: this.alarmPage.pageSize,
        thirdDeviceId: this.thirdDeviceId,
      };
      this.$fetch(api.electricDevice.queryElectricalFireAlarmInfo, params).then(
        (res) => {
          if (res.success) {
            this.alarmData = res.returnObj.list;
            this.alarmPage.total = res.returnObj.total;
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    },

    //导出
    exportDocument() {
      // if (this.selDev.length <= 0) {
      //   this.$message({
      //     message: this.$t('cameraList.message.checkOuter'),
      //     type: 'warning'
      //   })
      //   return;
      // }
      let params = {
        status: this.queryForm.status,
        thirdDeviceId: this.queryForm.thirdDeviceId,
        buildingCode: this.queryForm.buildingCode,
        deviceName: this.queryForm.deviceName,
        deviceWorkGroupCode: "",
        area: this.areaDevGroupCode,
        isDeviceWorkGroup: "",
        //
      };
      this.$fetchDownLoad(
        api.electricDevice.exportElectricalFireDeviceList,
        params,
        { responseType: "arraybuffer" }
      ).then((response) => {
        const content = response.data;
        const blob = new Blob([content], { type: "application/vnd.ms-excel" });
        const fileName = this.$t("cameraList.label.listFormat");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    // 请求设备列表
    requestList() {
      const param = {
        area: "",
        buildingCode: this.queryForm.buildingCode,
        deviceName: this.queryForm.deviceName,
        deviceWorkGroupCode:
          this.deviceWorkGroupCode !== "" ? this.deviceWorkGroupCode : "",
        isDeviceWorkGroup: "",
        pageNum: this.devicePage.currentPage,
        pageSize: this.devicePage.pageSize,
        status: this.queryForm.status,
        thirdDeviceId: this.queryForm.thirdDeviceId,
        ...this.queryForm,
      };
      this.$fetch(api.electricDevice.queryElectricalFireDeviceList, param).then(
        (res) => {
          if (res.success && res.returnObj.list) {
            this.deviceData = res.returnObj.list;
            this.devicePage.total = res.returnObj.total;
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    },
    // 根据查询条件查询列表
    getDevList() {
      this.devicePage.currentPage = 1;
      this.requestList();
    },
    // 设备组点击callback
    getDeviceWrokGroupCode(code) {
      this.areaDevGroupCode = "";
      this.deviceWorkGroupCode = code;
      this.getDevList();
    },
    handleSearchChange(param) {
      // console.log(this.searchForm, "====this.searchForm");
      // this.queryForm = this.searchForm;
      this.queryForm = param;
      this.devicePage.currentPage = 1;
      this.requestList();
    },

    getAreaTree() {
      this.$fetch(api.deviceMan.queryAssociationalDeviceTree).then((res) => {
        this.areaTreeData = res.returnObj;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.areaTreeData[0]);
        });
      });
    },

    getAccessDeviceInfoTree(data) {
      // const params = {
      //   systemId: 200000012,
      // };
      // this.$fetch(api.device.queryPlatSystemDeviceTree, params).then((res) => {
      //   if (res.success) {
      //     this.deviceTreeData= [res.returnObj];
      //     this.$nextTick(() => {
      //       this.$refs.vuetree.setCurrentKey("-1");
      //     });
      //   } else {
      //     this.$message.error(res.msgContent);
      //   }
      // });
    },
    getDeviceTreeData(data) {
      this.deviceTreeData = data;
    },
    // 设备类型查询按钮查询设备列表
    queryDevList() {
      this.devicePage.currentPage = 1;
      let params = {
        deviceId: this.devTyId,
        deviceName: this.devTyName,
        deviceType: this.checkDevType,
        cameraFeature: this.cameraFeature,
        page: this.devicePage.currentPage,
        pageSize: this.devicePage.pageSize,
        status: this.cameraStatus,
        isDeviceWorkGroup: this.isDeviceWorkGroup,
        deviceWorkGroupCode:
          this.deviceWorkGroupCode !== "" ? this.deviceWorkGroupCode : "",
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
    },
    // 设备类型重置搜索框内容
    emptyData() {
      this.cameraFeature = "";
      this.cameraStatus = "";
      this.devTyName = "";
      this.devTyId = "";
      this.isDeviceWorkGroup = "";
      this.checkedDevice = false;
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = 10;
      this.queryDevList();
    },
    // 区域重置搜索框内容
    emptyAreaData() {
      this.devAreaName = "";
      this.devAreaManu = "";
      this.cameraFeature = "";
      this.cameraStatus = "";
      this.checked = false;
      this.clickSearch = false;
      this.isArea = "";
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = 10;
      let params = {
        isArea: this.isArea,
        // area:'', //区域相关的
        // 修改3503问题单
        area: this.areaDevGroupCode,
        deviceId: "",
        cameraFeature: "",
        deviceName: "",
        deviceType: this.checkDevType,
        factoryId: "",
        page: 1,
        pageSize: 10,
        parentCodes: "", //区域相关的，父级code
        status: "",
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
    },
    // 确认修改
    batchModifYes() {
      this.batchModifShow = false;
      let params = {
        cameraFeature: this.batchModifForm.cameraFicType,
        cameraList: this.selThirdDev,
      };
      this.$fetch(api.deviceMan.updateCameraFeature, params).then((res) => {
        if (res.success === true) {
          this.$message.success(this.$t("cameraList.message.modifySucc"));
        } else {
          this.$message.error(res.msgContent);
        }
        this.$refs.devTab.selectClear();
        this.queryDevList();
      });
    },
    // 取消修改
    batchModifNo() {
      this.batchModifShow = false;
    },
    editDevDialogOpen() {
      this.$refs.editDev.clearValidate();
      this.$refs.editDev.devInData = this.currentRow;
      // console.log(this.$refs.editDev.devInData, "this.$refs.editDev.devInData");
      // console.log(this.$refs.editDev.devInOption.column);
    },
    // 修改设备详情
    modDel(row) {
      this.editDevDialog = true;
      this.currentRow = row;
    },

    // 选择左侧设备类型查询设备列表
    cheDevTy() {
      this.devicePage.currentPage = 1;
      let params = {
        area: "", //区域相关的
        deviceId: this.devTyId,
        deviceName: this.devTyName,
        deviceType: this.checkDevType,
        page: this.devicePage.currentPage,
        pageSize: this.devicePage.pageSize,
        parentCodes: "", //区域相关的，父级code
        // status: ''
        status: this.cameraStatus,
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
      //  this.activeState = index;
    },
    moveInDevice() {
      if (this.type.prop === "tab1") {
        if (this.selectedDeviceNode === "") {
          this.$message.warning("请选择挪入的设备组");
          return;
        }
        let params = {
          operateType: 1,
          deviceWorkGroupCode: this.selectedDeviceNode,
          deviceIdList: this.selDev,
        };
        this.$fetch(api.updateDeviceDeviceWorkGroup, params).then(
          (response) => {
            if (response.success) {
              this.$message({
                message: this.$t("cameraList.message.moveIntoSucc"),
                type: "success",
              });
              this.deviceTreeShow = false;
              // 刷新界面数据
              this.getDevList();
              this.$refs.devTab.selectClear();
            } else {
              this.$message({
                message: response.msgContent,
                type: "warning",
              });
            }
          }
        );
      } else {
        if (this.selectedAreaNode === "") {
          this.$message.warning(this.$t("cameraList.message.chooseEnterArea"));
          return;
        }
        let params = {
          area: this.selectedAreaNode,
          deviceIds: this.selDev,
        };
        this.$fetch(api.deviceMan.updateDeviceArea, params).then((response) => {
          if (response.success) {
            this.$message({
              message: this.$t("cameraList.message.moveIntoSucc"),
              type: "success",
            });
            this.deviceTreeShow = false;
            // 刷新界面数据
            this.getDevList();
            this.$refs.devTab.selectClear();
          } else {
            this.$message({
              message: response.msgContent,
              type: "warning",
            });
          }
        });
      }
    },
    selectAreaNode(data) {
      this.selectedAreaNode = data.areaDevGroupCode;
    },
    selectDeviceNode(data) {
      this.selectedDeviceNode = data.id;
    },
    // 树节点点击事件
    handleNodeClick(data) {
      this.devicePage.currentPage = 1;
      this.areaDevGroupCode = data.areaDevGroupCode;
      this.isArea = "";
      this.checked = false;
      let params = {
        area: this.areaDevGroupCode,
        buildingCode: this.queryForm.buildingCode,
        deviceName: this.queryForm.deviceName,
        deviceWorkGroupCode: "",
        isDeviceWorkGroup: "",
        pageNum: 1,
        pageSize: this.devicePage.pageSize,
        status: this.queryForm.status,
        thirdDeviceId: "",
      };
      // let params = {
      //   isArea: this.isArea,
      //   area: this.areaDevGroupCode, //区域相关的
      //   deviceId: '',
      //   deviceName: this.devAreaName,
      //   deviceType: this.checkDevType,
      //   factoryId: this.devAreaManu,
      //   page: this.devicePage.currentPage,
      //   pageSize: this.devicePage.pageSize,
      //   // parentCodes: this.areaDevGroupCode,  //区域相关的，父级code
      //   // status: ''
      //   status: this.status,
      //   isMap: this.isMap ? '1' : '',
      // }
      this.$fetch(
        api.electricDevice.queryElectricalFireDeviceList,
        params
      ).then((res) => {
        if (res.success && res.returnObj.list) {
          this.deviceData = res.returnObj.list;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
      // console.log(params, '=====params');
      // this.getDevPra = params;
      // this.getDevList();
    },
    // 编辑框保存按钮
    editDlgPre() {
      let data = {};
      data = this.$refs.editDev.devInData;
      this.$refs.editDev.validateForm().then((valid) => {
        if (valid) {
          let params = {
            abscissa: data.abscissa,
            buildingCode: data.buildingCode,
            ip: data.ip,
            deviceId: data.deviceId,
            port: data.port,
            latitude: data.latitude,
            longitude: data.longitude,
            isIndoor: data.isIndoor,
            height: data.height,
            ordinate: data.ordinate,
            slaveId: 1,
            thirdDeviceDesc: data.thirdDeviceDesc,
            thirdDeviceId: data.thirdDeviceId,
            thirdDeviceName: data.deviceName,
            width: data.width,
          };

          this.$fetch(
            api.electricDevice.updateElectricalFireDevice,
            params
          ).then((res) => {
            if (res.success === true) {
              this.$message.success(res.msgContent);
              this.$refs.editDev.devInData.resolutionWide = "";
              this.$refs.editDev.devInData.resolutionHigh = "";
              this.editDevDialog = false;
              this.getDevList();
            } else if (res.success === false) {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑框取消按钮
    editDlgCan() {
      this.editDevDialog = false;
    },
    // 分页事件
    selectPage(val) {
      this.$refs.devTab.selectClear();
      this.devicePage.currentPage = val;
      this.getDevPra.page = val;
      if (!this.clickSearch || !this.isArea) {
        this.getDevPra.isArea = this.isArea = "";
      }
      this.getDevPra.deviceType = this.checkDevType;
      this.getDevList();
    },
    // 重置搜索
    resetForm() {
      this.devicePage.pageSize = utils.Cache.get("CURRENT_PAGESIZE") || 10;
      this.devicePage.pageNo = 1;
      this.queryForm = {
        deviceName: "",
        thirdDeviceId: "",
        buildingCode: "",
        status: "",
      };
      // 请求设备列表
      this.requestList();
      this.devicePage.currentPage = 1;
    },
    changeSize(val) {
      this.getDevPra.pageSize = val;
      this.getDevPra.page = 1;
      this.getDevPra.deviceType = this.checkDevType;
      if (!this.clickSearch || !this.isArea) {
        this.getDevPra.isArea = this.isArea = "";
      }
      this.devicePage.pageSize = val;
      this.devicePage.currentPage = 1;
      this.getDevList();
    },
    // 切换左侧选项卡
    handleChange(column) {
      this.type = column;
      // 切换选项卡重置所有搜索条件
      this.devAreaName = "";
      this.devAreaManu = "";
      this.devTyName = "";
      this.devTyId = "21";
      this.isArea = "";
      this.isDeviceWorkGroup = "";
      this.cameraStatus = "";
      this.cameraFeature = "";
      this.checked = false;
      this.checkedDevice = false;
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = 10;
      this.deviceTreeShow = false;
      if (this.type.prop === "tab1") {
        this.activeState = Number;
        // 切换头部按钮
        this.accType = true;
        this.accReg = false;
        // 切换表格样式
        this.deviceOption = tableOption(true, false);
        // 切换头部搜索条件
        this.devTypeSer = true;
        this.devAreaSer = false;
        // 清空请求条件，请求全量数据
        // this.initGet();
      } else if (this.type.prop === "tab2") {
        this.accType = false;
        this.accReg = true;
        this.deviceOption = tableOption(false, true);
        this.devTypeSer = false;
        this.devAreaSer = true;
        // this.initGet();
      }
      this.$nextTick(() => {
        this.$refs.devTab.reset();
      });
    },

    setCheckDevType() {
      if (this.$route.query.device.deviceTypeId) {
        this.checkDevType = this.$route.query.device.deviceTypeId;
        Cache.put("deviceTypeId", this.$route.query.device.deviceTypeId);
        this.paramsType = this.$route.query.device.deviceType;
      } else {
        this.checkDevType = Cache.get("deviceTypeId");
      }
    },
    // 初始化查询条件，查询全量数据；
    initGet() {
      // if (this.$route.query.device.deviceTypeId) {
      //   this.checkDevType = this.$route.query.device.deviceTypeId;
      //   Cache.put('deviceTypeId', this.$route.query.device.deviceTypeId);
      // } else {
      //   this.checkDevType = Cache.get('deviceTypeId');
      // }
      this.setCheckDevType();
      let params = {
        area: "", //区域相关的
        deviceId: "",
        deviceName: "",
        deviceType: "21",
        page: this.devicePage.currentPage,
        pageSize: this.devicePage.pageSize,
        parentCodes: "", //区域相关的，父级code
        // status: ''
        status: this.cameraStatus,
        deviceWorkGroupCode:
          this.deviceWorkGroupCode !== "" ? this.deviceWorkGroupCode : "",
        isMap: this.isMap ? "1" : "",
      };
      // console.log('--this.deviceWorkGroupCode-----', this.deviceWorkGroupCode);
      this.getDevPra = params;
      this.getDevList();
    },
    // 勾选事件
    selectionChange(selections) {
      if (
        selections.length < this.devicePage.pageSize &&
        selections.length > 0
      ) {
        setTimeout(() => {
          $(".el-table__fixed-header-wrapper label.el-checkbox>span").attr(
            "class",
            "el-checkbox__input is-indeterminate"
          );
        }, 200);
      }
      this.selDev = [];
      this.selThirdDev = [];
      this.selectedDevs = selections;
      selections.map((item) => {
        this.selDev.push(item.deviceId);
        this.selThirdDev.push(item.thirdDeviceId);
      });
    },
    retBtn() {
      this.$router.go(-1);
    },

    update(row) {
      this.rowInfo = { ...row };
      // this.editDevDialog = true
      this.editDevDialog = true;
      this.dialogTitle = "修改设备";
      this.$nextTick(() => {
          // this.$refs.editDev.$refs.iocForm.columnOption[0].column[14].display = false;
          // this.$refs.editDev.$refs.iocForm.columnOption[0].column[15].display = false;
          // this.$refs.editDev.$refs.iocForm.columnOption[0].column[11].display = true;
          // this.$refs.editDev.$refs.iocForm.columnOption[0].column[12].display = true;
          // this.$refs.editDev.$refs.iocForm.columnOption[0].column[13].display = true;
          // this.$refs.editDev.$refs.iocForm.columnOption[0].column[16].display = true;
          // this.$refs.editDev.$refs.iocForm.columnOption[0].column[17].display = true;
        this.$refs.editDev.devInData = Object.assign(
          row,
          row.deviceExtendInfoMap
        );
        // this.$refs.editDev.devInData.isIndoor = parseInt(row.isIndoor)
        // console.log(this.$refs.editDev.devInData);
      });
    },
    queryBuildingTree() {
      this.$fetch(api.queryBuildingTree).then((res) => {
        const result = this.menusDataPro(res.returnObj);
        this.treeData = Object.freeze(result);
        this.expandedKeys = this.expandedKeys.length
          ? this.expandedKeys
          : [this.treeData[0].id];
        // this.$refs.tree.setCheckedKeys([this.devInData.buildingCode] || []);
      });
    },
    // 打开楼栋选择
    openBuilding() {
      this.showBuilding = true;
      this.queryBuildingTree();
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.buildingCode;
          entity.name = item.buildingName;
          entity.parentCode = item.parentCode;
          entity.type = item.type;
          entity.fileCode = item.fileCode;
          entity.desc = item.desc;
          entity.isLeaf = !item.hasLeaf || !item.subBuildingList;
          if (item.subBuildingList) {
            entity.children = self.menusDataPro(item.subBuildingList);
          }
          result.push(entity);
        });
        return result;
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.vcnDeviceList {
  width: 100%;
  height: 100%;
  position: relative;
  // .ioc-table {
  //   height: 580px;
  // }
  // .alarm-dialog {
  //   .el-dialog__body {
  //     .ioc-table {
  //       height: 500px;
  //     }
  //   }
  // }
  .el-col {
    // margin-bottom: 20px;
  }
  .map-choose {
    position: absolute;
    right: -5px;
    top: 0px;
  }
  .devTyList {
    padding: 3px 10px;
    margin: 5px 10px;
    cursor: pointer;
  }
  .left_title {
    border-left: 4px solid #407aee;
    padding-left: 8px;
    margin: 16px;
  }
  .device-tab {
    display: flex;
    margin: 0 16px 0px 16px;
    .tab {
      color: #9aa6c1;
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #707070;
      &:hover {
        color: #fff;
        cursor: pointer;
      }
    }
    .active {
      color: #fff;
      border-color: #407aee;
    }
  }
  .device-search {
    display: flex;
    margin: 15px 16px;
    height: 28px;
    .el-input {
      width: 100%;
    }
  }
  .devTyListCheck {
    @include set_theme_color(background-color, page-bg-color);
  }
  .left-type_area {
    height: calc(100% - 100px);
    position: relative;
    flex: 1;
    overflow: hidden;
    @include set_theme_color(background-color, left-menu-bg-color);
  }
  /* .el-dialog__footer {
    padding: 20px;
    padding-top: 10px;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  } */

  .upload-demo {
    margin: 0 10px;
  }

  .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
  .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 10px;
  }
}
.el-select {
  width: 100%;
}
</style>
